import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckboxComponent,
      multi: true,
    },
  ],
  standalone: false,
})
export class CheckboxComponent implements ControlValueAccessor, Validator, OnInit {
  @Input() disabled = false;
  @Input() valueType: 'number' | 'boolean' = 'boolean';
  @Input() roundBorder? = false;

  innerControl = new FormControl();

  ngOnInit() {
    this.innerControl.valueChanges.subscribe((x) => {
      if (this.propagateOnChange) {
        this.propagateOnChange(this.valueType === 'number' ? boolNumberConverter.outputFn(x) : x);
      }
    });
  }

  /** ControlValueAccessor Implementation */

  writeValue(val: number | boolean): void {
    if (this.valueType === 'number') {
      val = boolNumberConverter.outputFn(!!val);
    }

    this.innerControl.setValue(val, { emitEvent: false, onlySelf: true });
  }

  propagateOnChange?: (_: any) => void;
  registerOnChange(fn: (_: any) => void): void {
    this.propagateOnChange = fn;
  }

  @HostListener('click')
  propagateOnTouched?: () => void;
  registerOnTouched(fn: () => void): void {
    this.propagateOnTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.innerControl.disable({ emitEvent: false, onlySelf: true }) : this.innerControl.enable({ emitEvent: false, onlySelf: true });
  }

  validate(_control: AbstractControl): ValidationErrors | null {
    return this.innerControl.errors;
  }
}

const boolNumberConverter: { inputFn: (x: number) => boolean; outputFn: (x: boolean) => number } = {
  inputFn: (number) => number > 0,
  outputFn: (bool) => (bool ? 1 : 0),
};
